import { createSelector } from '@reduxjs/toolkit';
import { selectFloorn } from 'shared/selectors/jsonQuery';

export const selectFloornFilter = createSelector(selectFloorn, range => ({
  value: { min: range?.gte ?? null, max: range?.lte ?? null },
  min: 1,
  max: 200,
}));
